import API from "../api/apiUser";

export const ContactService = {
    submitInquiry: async (formData) => {
        try {
            const response = await API.post("/user/contact", formData);
            return response.data;
        } catch (error) {
            console.error("Error submitting contact inquiry:", error);
            throw error;
        }
    },
    getSettings: async () => {
        try {
            const response = await API.get("/user/contact/settings");
            return response.data;
        } catch (error) {
            console.error("Error fetching contact settings:", error);
            throw error;
        }
    }
};
